import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviFacturesAvantEcheanceState } from '.';

export const getters: GetterTree<SuiviFacturesAvantEcheanceState, RootState> = {
    getSuiviFacturesAvantEcheanceScroll(state) {
        return state.scroll;
    },
    getSuiviFacturesAvantEcheanceItems(state) {
        return state.facturesAvantEcheance;
    },
    getSuiviFacturesAvantEcheanceIsLoading(state) {
        return state.isLoading;
    },
    getSuiviFacturesAvantEcheancePage(state) {
        return state.page;
    },
    getSuiviFacturesAvantEcheanceNbOfPages(state) {
        return state.nbOfPages;
    },
    getSuiviFacturesAvantEcheanceSort(state) {
        return state.sort;
    },
    getSuiviFacturesAvantEcheanceCount(state) {
        return state.count;
    },
};